import { SimilarByPatternGeneralSettings } from 'src/services/src/service/similar-by-pattern/similarByPattern';
import { Dispatch } from 'src/components-bl/types';
import {
  UpdateSimilarByPatternSettingsPayload,
  GetSimilarByPatternSettingsArgs,
  GetSimilarByPatternSettingsRequestPayload,
  GetSimilarByPatternSettingsSuccessPayload,
  GetSimilarByPatternSettingsErrorPayload,
  UpdateSimilarByPatternSettingsRequestPayload,
  UpdateSimilarByPatternSettingsSuccessPayload,
  UpdateSimilarByPatternSettingsErrorPayload,
  SimilarByPatternActionTypes,
  GetSimilarByPatternSettingsRequestAction,
  GetSimilarByPatternSettingsErrorAction,
  GetSimilarByPatternSettingsSuccessAction,
  UpdateSimilarByPatternSettingsRequestAction,
  UpdateSimilarByPatternSettingsSuccessAction,
  UpdateSimilarByPatternSettingsErrorAction,
  NotifySimilarByPatternSettingsIsDirtyAction,
  NotifySimilarByPatternSettingsIsDirtyActionPayload,
} from './types';

const similarByPatternService = new SimilarByPatternGeneralSettings();

/* --= Actions =-- */
const similarByPatternSettingsActions = {
  getSimilarByPatternSettingsRequest: (
    payload: GetSimilarByPatternSettingsRequestPayload
  ): GetSimilarByPatternSettingsRequestAction => {
    return {
      type: SimilarByPatternActionTypes.GetSimilarByPatternSettingsRequest,
      payload,
    };
  },
  getSimilarByPatternSettingsSuccess: (
    payload: GetSimilarByPatternSettingsSuccessPayload
  ): GetSimilarByPatternSettingsSuccessAction => {
    return {
      type: SimilarByPatternActionTypes.GetSimilarByPatternSettingsSuccess,
      payload,
    };
  },
  getSimilarByPatternSettingsError: ({
    error,
  }: GetSimilarByPatternSettingsErrorPayload): GetSimilarByPatternSettingsErrorAction => {
    return {
      type: SimilarByPatternActionTypes.GetSimilarByPatternSettingsError,
      payload: { error },
    };
  },
  updateSimilarByPatternSettingsRequest: (
    payload: UpdateSimilarByPatternSettingsRequestPayload
  ): UpdateSimilarByPatternSettingsRequestAction => {
    return {
      type: SimilarByPatternActionTypes.UpdateSimilarByPatternSettingsRequest,
      payload,
    };
  },
  updateSimilarByPatternSettingsSuccess: (
    payload: UpdateSimilarByPatternSettingsSuccessPayload
  ): UpdateSimilarByPatternSettingsSuccessAction => {
    return {
      type: SimilarByPatternActionTypes.UpdateSimilarByPatternSettingsSuccess,
      payload,
    };
  },
  updateSimilarByPatternSettingsError: (
    payload: UpdateSimilarByPatternSettingsErrorPayload
  ): UpdateSimilarByPatternSettingsErrorAction => {
    return {
      type: SimilarByPatternActionTypes.UpdateSimilarByPatternSettingsError,
      payload,
    };
  },

  notifyIsDirtyState: (
    payload: NotifySimilarByPatternSettingsIsDirtyActionPayload
  ): NotifySimilarByPatternSettingsIsDirtyAction => {
    return {
      type: SimilarByPatternActionTypes.NotifySimilarByPatternSettingsIsDirty,
      payload,
    };
  },
};

export const similarByPatternSettingsActionsMethods = {
  notifyIsDirty:
    ({ isDirty }: NotifySimilarByPatternSettingsIsDirtyActionPayload) =>
    async (dispatch: Dispatch): Promise<void> => {
      dispatch(similarByPatternSettingsActions.notifyIsDirtyState({ isDirty }));
    },

  fetchSimilarByPatternSettings:
    ({ shopId }: GetSimilarByPatternSettingsArgs) =>
    async (dispatch: Dispatch): Promise<void> => {
      try {
        dispatch(similarByPatternSettingsActions.getSimilarByPatternSettingsRequest({ shopId }));
        const { numberOfResultsToDisplay } = await similarByPatternService.get({
          shopId,
        });
        dispatch(
          similarByPatternSettingsActions.getSimilarByPatternSettingsSuccess({
            shopId,
            numberOfResultsToDisplay,
          })
        );
      } catch (error) {
        dispatch(similarByPatternSettingsActions.getSimilarByPatternSettingsError({ error }));
      }
    },

  updateSimilarByPatternSettings:
    ({ shopId, numberOfResultsToDisplay }: UpdateSimilarByPatternSettingsPayload) =>
    async (dispatch: Dispatch): Promise<void> => {
      try {
        dispatch(
          similarByPatternSettingsActions.updateSimilarByPatternSettingsRequest({
            shopId,
            numberOfResultsToDisplay,
          })
        );

        await similarByPatternService.update({
          shopId,
          numberOfResultsToDisplay,
        });

        dispatch(
          similarByPatternSettingsActions.updateSimilarByPatternSettingsSuccess({
            shopId,
            numberOfResultsToDisplay,
          })
        );
      } catch (error) {
        dispatch(similarByPatternSettingsActions.updateSimilarByPatternSettingsError({ error }));
      }
    },
};
